import { z } from "zod";

import { createQueryRequestDefinition } from "~/lib/network/definitions/create";

import {
  lookupBillingResponseSchema,
  lookupOrgResponseSchema,
  lookupUserResponseSchema,
  internalAccountsResponseSchema,
  internalTestAccountsResponseSchema,
  userSearchResponseSchema,
} from "./schemas";

export const lookupUserByIdQuery = createQueryRequestDefinition({
  queryKey: ["oasis", "lookup", "user"],
  host: "cap-srv",
  method: "GET",
  path: "oasis/lookup/user/:userId",
  responseSchema: lookupUserResponseSchema,
});

export const lookupOrgByIdQuery = createQueryRequestDefinition({
  queryKey: ["oasis", "lookup", "org"],
  host: "cap-srv",
  method: "GET",
  path: "oasis/lookup/org/:orgId",
  responseSchema: lookupOrgResponseSchema,
});

// Billing resolves live against RevenueCat/Stripe, so it is a separate query that
// loads after the user/org lookup instead of slowing it down.
export const lookupUserBillingQuery = createQueryRequestDefinition({
  queryKey: ["oasis", "lookup", "user", "billing"],
  host: "cap-srv",
  method: "GET",
  path: "oasis/lookup/user/:userId/billing",
  responseSchema: lookupBillingResponseSchema,
});

export const lookupOrgBillingQuery = createQueryRequestDefinition({
  queryKey: ["oasis", "lookup", "org", "billing"],
  host: "cap-srv",
  method: "GET",
  path: "oasis/lookup/org/:orgId/billing",
  responseSchema: lookupBillingResponseSchema,
});

export const activeEmailDuplicatesQuery = createQueryRequestDefinition({
  queryKey: ["oasis", "lookup", "active-email-duplicates"],
  host: "cap-srv",
  method: "GET",
  path: "proxy/oasis/camel/oasis/users/:userId/active-email-duplicates",
  responseSchema: z.object({
    email: z.string().nullable(),
    userIds: z.array(z.string()),
  }),
});

export const userSearchQuery = createQueryRequestDefinition({
  queryKey: ["oasis", "user", "search"],
  host: "cap-srv",
  method: "GET",
  path: "oasis/user/search",
  paramsSchema: z.object({
    query: z.string(),
  }),
  responseSchema: userSearchResponseSchema,
});

export const internalAccountsQuery = createQueryRequestDefinition({
  queryKey: ["oasis", "lookup", "internal-accounts"],
  host: "cap-srv",
  method: "GET",
  path: "oasis/lookup/internal-accounts",
  responseSchema: internalAccountsResponseSchema,
});

export const internalTestAccountsQuery = createQueryRequestDefinition({
  queryKey: ["internal", "test-accounts"],
  host: "cap-srv",
  method: "GET",
  path: "internal/test-accounts",
  responseSchema: internalTestAccountsResponseSchema,
});
